
(function ($) {
  $(document).ready(function() {
    $('.h-banner__header').bxSlider({
      mode: 'fade',
      auto: true,
      speed: 1000,
      pager: false,
      controls: false,
    });

    resizeHeroBanner();
    $(window).resize(resizeHeroBanner);
  });

  var resizeHeroBanner = function($item) {
    var $item = $('.h-banner__bkg');
    $item.removeAttr('style');
    var css,
        pratio = $item.parent().width() / $item.parent().height();

    if (pratio > 1) {
      css = { width:'100%' };
    }
    else {
      css = { width: '100%' };
    }
    $item.removeAttr('style').css({
      width: (pratio >= 1 ? 100 : 100 / pratio) + '%',
    });
  }
})(jQuery);

(function ($) {
  $(document).ready(function() {
    resizeHeaderBanner();
    $(window).resize(resizeHeaderBanner);

    positionImageForMobile();
    $(window).resize(positionImageForMobile);
  });

  var positionImageForMobile = function() {

  };

  var resizeHeaderBanner = function() {
    var $item = $('.h-header__image');
    $item.removeAttr('style');
    var css,
        h = $item.height(),
        w = $item.width(),
        pratio = w / h;

    // $('lottie-player',$item).width(h * 0.68);
    $('lottie-player', $item).width(h * 1.009);
  }

  var positionImageForMobile = function() {
    var w = $(window).width();
    var mobileImageInserted = $('.h-header .c-anim__image').length > 0;
    if (w < Theme.breakpoint.max && !mobileImageInserted) { //put
      var $image = $('.c-anim__image:first').clone();
      $image.insertAfter('.h-header__header');
    }
    else if (w > Theme.breakpoint.max && mobileImageInserted) {
      $('.h-header .c-anim__image').remove();
    }
  }
})(jQuery);

(function ($) {
  Theme.wheel = lottie.loadAnimation({
    container: $('.h-wheel__wheel')[0], // the dom element that will contain the animation
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: '/img/animations/Service_Wheel_NEW.json' // the path to the animation json
  });

  $(document).ready(function() {
    Theme.wheel.goToAndStop(0,true);
    // Theme.wheel.playSegments([0, 49], true);

    var t = setTimeout(function() {
      Theme.initWheel();
    },100);
    $(window).scroll(Theme.initWheel);

    // Circle functions light
    var $ul = $('<ul class="wheel-nav" />');
    $('.h-wheel__copy-item:not(:first) .h1').each(function () {
      $ul.append('<li>' + $(this).text() + '</li>');
    });
    $('li', $ul).hover(function() {
      var i = $ul.children().index(this);
      hoverWheelItem(i);
    },function() {
      var i = $ul.children().index(this);
      hoverWheelItem(i,true);
    }).click(function () {
      var i = $ul.children().index(this);
      $('.h-wheel__copy-item').removeClass('js-active').eq(i + 1).addClass('js-active');
      clickWheelItem(i);
    });
    $ul.hover(null,function() {
      Theme.wheelPos = false;
    });
    $('.h-wheel__wheel').append($ul);
  });

  Theme.initWheel = function() {
    var h = $(window).height(),
        wTop = $(window).scrollTop(),
        wBottom = wTop + h,
        offsetTop = $('.h-wheel').offset().top;
    if (wBottom > offsetTop && !$('.h-wheel').hasClass('js-wheel-initialized')) {
      Theme.wheel.playSegments([0, 49], true);
      $('.h-wheel').addClass('js-wheel-initialized')
    }
  };

  Theme.wheelPositions = {
    0: {
      hover: [450,499],
      click: [500,549],
    },
    1: {
      hover: [350,399],
      click: [400,449],
    },
    2: {
      hover: [150, 199],
      click: [200, 249],
    },
    3: {
      hover: [250,299],
      click: [300,349],
    },
    4: {
      hover: [50,99],
      click: [100,149],
    },
    5: {
      hover: [550,599],
      click: [600,649],
    },
  };

  var hoverWheelItem = function(i,off) {
    off = typeof off === 'undefined' ? false : off;
    var tmp;

    if (off) {
      Theme.wheel.playSegments(Theme.wheelPositions[i].hover.reverse(), true);
    }
    else {
      // if (i !== false && i == (Theme.wheelPos - 1)) {
      //   tmp = [
      //     wheelPositions[i].hover[1],
      //     wheelPositions[Theme.wheelPos].hover[1],
      //   ];
      //   Theme.wheel.playSegments(tmp, true);
      // }
      // else {
      Theme.wheel.playSegments(Theme.wheelPositions[i].hover, true);
      // }
      Theme.wheelPos = i;
    }
  };
  var clickWheelItem = function(i) {
    Theme.wheelPos = i;
    Theme.wheel.playSegments(Theme.wheelPositions[i].click, true);
  };
})(jQuery);

(function ($) {
  $(document).ready(function() {
    $('.c-faq__header, .c-faq__close').click(function(e) {
      e.stopPropagation();
      var $row = $(this).closest('.c-faq');
      if ($row.hasClass('js-open')) {
        toggleFaq($row,false);
      }
      else {
        toggleFaq($row,true);
        toggleFaq($('.c-faq').not($row),false);
      }
    });
  });

  var toggleFaq = function($rows,set) {
    $rows.each(function() {
      var $row = $(this);
      if (set) {
        $row.addClass('js-open');
        $('.c-faq__copy', $row).slideDown(Theme.eta);
      }
      else {
        $row.removeClass('js-open');
        $('.c-faq__copy', $row).slideUp(Theme.eta);
      }
    });
  };
})(jQuery);

Theme.$form = $('#lasso-form');
Theme.getFormData = function() {
  var unindexed_array = Theme.$form.serializeArray();
  var indexed_array = {};

  $.map(unindexed_array, function (n, i) {
    if (typeof indexed_array[n['name']] === 'undefined') {
      indexed_array[n['name']] = n['value'];
    }
    else {
      if (typeof indexed_array[n['name']] === 'string') {
        var first = indexed_array[n['name']];
        indexed_array[n['name']] = [
          first,
          n['value']
        ]
      }
      else {
        indexed_array[n['name']].push(n['value']);
      }
    }
  });

  return indexed_array;
};

Theme.formValidate = function() {
  var data = Theme.getFormData();
  var ret = true;
  for (var i in data) {
    var retTmp = true;
    if (i != 'g-recaptcha-response' && i != 'message') {
      retTmp = data[i] == '' ? false : retTmp;
      retTmp = i == 'email' && !data[i].match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) ? false : retTmp;
      retTmp = i == 'phone' && !data[i].match(/^\d{10}$/) ? false : retTmp;

      ret = !retTmp ? retTmp : ret;
      $('[name="' + i + '"]', Theme.$form)[!retTmp ? 'addClass' : 'removeClass']('js-error');
    }
  }
  return ret;
};

(function ($) {
  $(document).ready(function() {
    $('.c-form :input:not([type="radio"]):not([type="checkbox"]):not(select)').change(Theme.formValidate);
    $('.c-form__action .b').click(function(e) {
      e.preventDefault();
      var data = Theme.getFormData();
      if (grecaptcha.getResponse().length === 0 || !Theme.formValidate()) {
        // ERROR
        // e.preventDefault();
      }
      else {
        //Missing data
        data.address = '';
        data.city = '';
        data.province = '';
        // data.postal = '';
        data.country = '';

        $.ajax({
          url: '/signup.php',
          data: data,
          success: function(r) {
            console.log(r);
            $('.c-form__form--form').slideUp(Theme.eta);
            $('.c-form__form--success').slideDown(Theme.eta);
          },
          error: function(r) {
            console.log(r);
          },
        });

        $('span', this).text('Submitted');
        $(this).prop('disabled', true);
      }
    });
  });
})(jQuery);

(function ($) {

  $(document).ready(function() {
    positionAnimImages();
    $(window).resize(positionAnimImages);
  });

  var positionAnimImages = function () {
    var w = $(window).width();
    var imageMoved = $('.c-number:first .c-anim__image').length > 0;
    var imageNotMoved = $('.c-anim:first .c-anim__image').length > 0;

    $('.c-list').each(function () {
      var $row = $(this);
      var $image = $('.c-anim__image', $row);
      if (w < Theme.breakpoint.medium && imageNotMoved) { //put
        $image.insertAfter($('.c-number__header', $row));
      }
      else if (w > Theme.breakpoint.medium && imageMoved) { //put back
        $image.prependTo($('.c-anim__inner', $row));
      }
    });
  };

})(jQuery);
